<template>
  <div>
    <div class="profileClassFirst">
      <main class="profile">
        <div class="profile-bg"></div>

        <section class="container1">
          <Skeletor
            v-if="LoadingSkeleton"
            class="profile-image profileImageSkeletor"
            style="border-radius: 30px; background: rgb(163, 219, 213)"
          />

          <figure v-if="!LoadingSkeleton" class="profile-image">
            <img :src="completeInfos?.avatar" :alt="completeInfos?.nickname" />
          </figure>

          <section
            class="profile-info"
            :class="{ infoSkeleton: LoadingSkeleton }"
          >
            <Skeletor
              v-if="LoadingSkeleton"
              class="first-name firstNameSkeletor"
              style="
                width: 50%;
                position: absolute;
                top: -80px;
                right: 20px;
                height: 50px;
                border-radius: 10px;
                background: rgb(163, 219, 213);
              "
            />
            <h1 v-if="!LoadingSkeleton && $store.state.auth" class="first-name">
              {{ completeInfos?.nickname }}
            </h1>

            <Skeletor
              v-if="LoadingSkeleton"
              class="PhoneClassNumber"
              style="
                height: 46px;
                border-radius: 10px;
                background: rgb(163, 219, 213);
              "
            />

            <div
              v-if="!LoadingSkeleton && $store.state.auth"
              class="PhoneClassNumber"
            >
              <p>شماره همراه :</p>
              <span>{{ $store.state.auth.mobile }}</span>

              <VsxIcon
                class="LogoutCurve1 profileLogoutCurve"
                @click="ShowModel = true"
                iconName="UserEdit"
                :size="32"
                color="#0077b6"
                type="linear"
              />
              <VsxIcon
                class="LogoutCurve"
                @click="Logout()"
                iconName="LogoutCurve"
                :size="32"
                color="red"
                type="linear"
              />
            </div>

            <Skeletor
              v-if="LoadingSkeleton"
              class="PhoneClassNumber phoneclassSkeletor"
              style="
                height: 46px;
                border-radius: 10px;
                margin-bottom: 14px;
                background: rgb(163, 219, 213);
              "
            />

            <Skeletor
              v-if="LoadingSkeleton"
              class="PhoneClassNumber creditSign creditSignSkeletor"
              style="
                height: 40px;
                border-radius: 10px;
                margin-bottom: 8px;
                background: rgb(163, 219, 213);
              "
            />

            <div
              v-if="!LoadingSkeleton"
              class="PhoneClassNumber addressProfile creditSign"
            >
              <p>موجودی :</p>
              <span
                >{{ formatPrice($store.state.auth.credit) }}
                {{ $store.state.c_set.currency }}
              </span>
            </div>

            <div
              v-if="!LoadingSkeleton"
              class="PhoneClassNumber addressProfile requestVisit"
            >
              <p>ثبت درخواست بازدید :</p>
              <label
                class="switchInput"
                :class="{ loading: requestStatLaoing }"
              >
                <input
                  ref="visitStat"
                  type="checkbox"
                  v-model="visitStatChecked"
                  @change="handleToggle"
                />
                <span class="slider"></span>
              </label>
            </div>
            <!-- <div v-if="!LoadingSkeleton" class="creditSign">
                <div class="PhoneClassNumber addressProfile">
                  <p>موجودی :</p>
                  <span>48,000,000 تومان </span>
                </div>
                <router-link to="/wallet" class="addCreditBtn">
                  <span>افزایش اعتبار</span>
                  <VsxIcon
                    @click="ShowModel = true"
                    iconName="Add"
                    :size="20"
                    color="#fff"
                    type="linear"
                  />
                </router-link>
              </div> -->
            <!--          <h1 class="second-name">هادیزاده</h1>-->

            <Skeletor
              v-if="LoadingSkeleton"
              class="profileEditBtn profileEditBtnSkeletor"
              style="
                height: 48px;
                border-radius: 10px;
                background: rgb(163, 219, 213);
                margin-bottom: 8px;
              "
            />

            <div v-if="!LoadingSkeleton" class="mobileProfileBtns">
              <div class="profileEditBtn" @click="profileEditHadler">
                ویرایش پروفایل
                <VsxIcon
                  iconName="UserEdit"
                  :size="22"
                  color="#fff"
                  type="linear"
                />
              </div>
              <router-link v-if="$store.state.c_set && $store.state.c_set.credit_visible" to="/wallet" class="profileEditBtn addCreditbtn">
                <span> افزایش اعتبار</span>
                <VsxIcon iconName="Add" :size="22" color="#fff" type="linear" />
              </router-link>
              <div class="logoutBtn" @click="Logout()">
                <!-- <VsxIcon
                class="LogoutCurve mobileLogoutBtn"
                iconName="LogoutCurve"
                :size="24"
                color="#0096c7"
                type="linear"
              /> -->
                <i class="fa-solid fa-arrow-right-from-bracket"></i>
              </div>
            </div>

            <!-- <footer v-if="!LoadingSkeleton" class="social-media-icons">
              <a href="#" target="_blank">
                <i class="fab fa-instagram"></i>
              </a>
              <a href="#" target="_blank">
                <i class="fab fa-telegram"></i>
              </a>
              <a href="#" target="_blank">
                <i class="fab fa-whatsapp"></i>
              </a>
              <a
                class="profileCallIcon"
                style="display: flex; justify-content: center"
                href="#"
                target="_blank"
              >
                <VsxIcon
                  iconName="Call"
                  :size="38"
                  color="#0096c7"
                  type="linear"
                />
              </a>
            </footer> -->
          </section>

          <section v-if="!LoadingSkeleton" class="statistics mobileStatistics">
            <p @click="selectedFollowHandler('follower', true)">
              <strong>{{ completeInfos?.follower }}</strong> دنبال‌کننده
            </p>
            <p @click="selectedFollowHandler('following', true)">
              <strong>{{ completeInfos?.following }}</strong> دنبال‌شونده
            </p>
            <p @click="openComponent('ShowFile')">
              <strong v-if="completeInfos">{{
                completeInfos?.posts.total || 0
              }}</strong>
              <strong v-else>0</strong>
              {{ $store.state.auth?.role == "builder" ? "پروژه" : "آگهی" }}
            </p>
          </section>
        </section>

        <div v-if="LoadingSkeleton" class="desktopStatisticsWrapperSk">
          <Skeletor class="desktopStatisticsSk" />
          <Skeletor class="desktopStatisticsSk" />
          <Skeletor class="desktopStatisticsSk" />
        </div>

        <section v-if="!LoadingSkeleton" class="statistics desktopStatistics">
          <p @click="selectedFollowHandler('follower', true)" class="pointer">
            <strong>{{ completeInfos?.follower }}</strong> دنبال‌کننده
          </p>
          <p @click="selectedFollowHandler('following', true)" class="pointer">
            <strong>{{ completeInfos?.following }}</strong> دنبال‌شونده
          </p>
          <p @click="openComponent('ShowFile')">
            <strong>{{ completeInfos?.posts?.total || 0 }}</strong> آکهی
          </p>
        </section>

        <Skeletor
          v-if="LoadingSkeleton"
          class="statistics desktopStatistics desktopAddCreditskeletor"
          style="
            width: 93%;
            margin: auto;
            margin-top: 0;
            height: 64px;
            border-radius: 10px;
            background: rgb(163, 219, 213);
          "
        />
        <section v-if="!LoadingSkeleton" class="desktopAddCreditBtnWrapper">
          <div class="addCreditLabel">
            <span>موجودی:</span>
            {{ formatPrice($store.state.auth.credit) }}
            {{ $store.state.c_set.currency }}
          </div>
          <router-link v-if="$store.state.c_set && $store.state.c_set.credit_visible" to="/wallet" class="desktopAddCreditBtn">
            <span>افزایش اعتبار</span>
            <VsxIcon iconName="Add" :size="28" color="#fff" type="linear" />
          </router-link>
        </section>
      </main>

      <div class="ShowChildTemplate">
        <Skeletor
          v-if="LoadingSkeleton"
          class="ChildShowChildTemplate"
          style="background: rgb(163, 219, 213)"
        />
        <Skeletor
          v-if="LoadingSkeleton"
          class="ChildShowChildTemplate"
          style="background: rgb(163, 219, 213)"
        />
        <Skeletor
          v-if="LoadingSkeleton"
          class="ChildShowChildTemplate"
          style="background: rgb(163, 219, 213)"
        />
        <Skeletor
          v-if="LoadingSkeleton"
          class="ChildShowChildTemplate"
          style="background: rgb(163, 219, 213)"
        />
        <Skeletor
          v-if="LoadingSkeleton"
          class="ChildShowChildTemplate"
          style="background: rgb(163, 219, 213)"
        />
        <Skeletor
          v-if="LoadingSkeleton"
          class="ChildShowChildTemplate"
          style="background: rgb(163, 219, 213)"
        />
        <Skeletor
          v-if="LoadingSkeleton"
          class="ChildShowChildTemplate"
          style="background: rgb(163, 219, 213)"
        />
        <Skeletor
          v-if="LoadingSkeleton"
          class="ChildShowChildTemplate"
          style="background: rgb(163, 219, 213)"
        />
        <Skeletor
          v-if="LoadingSkeleton"
          class="ChildShowChildTemplate"
          style="background: rgb(163, 219, 213)"
        />

        <div v-if="!LoadingSkeleton">
          <!--       CreateMelk   //////////-->
          <div
            @click="$router.push('/user-profile/my-notif')"
            style="margin-bottom: 20px"
            class="ChildShowChildTemplate"
          >
            <VsxIcon
              iconName="Notification"
              :size="32"
              :color="color"
              type="linear"
            />
            <p>اعلان های من</p>

            <div
              v-if="completeInfos && completeInfos.notify > 0"
              class="notifNum"
            >
              {{ completeInfos.notify }}
            </div>
            <VsxIcon
              iconName="ArrowLeft"
              :size="20"
              :color="color"
              class="ShowIconK"
              type="linear"
            />
          </div>
          <div
            @click="
              changeCompRouteHandler('addFiles', '/user-profile/add-file')
            "
            style="margin-bottom: 20px"
            class="ChildShowChildTemplate"
          >
            <VsxIcon iconName="Add" :size="32" :color="color" type="linear" />
            <p>ثبت آگهی</p>
            <VsxIcon
              iconName="ArrowLeft"
              :size="20"
              :color="color"
              class="ShowIconK"
              type="linear"
            />
          </div>

          <!--         ShowFile //////////-->
          <div
            @click="changeCompRouteHandler('myAds', '/user-profile/my-files')"
            style="margin-bottom: 20px"
            class="ChildShowChildTemplate"
          >
            <VsxIcon
              iconName="Notepad"
              :size="32"
              :color="color"
              type="linear"
            />
            <p>آگهی‌های من</p>
            <VsxIcon
              iconName="ArrowLeft"
              :size="20"
              :color="color"
              class="ShowIconK"
              type="linear"
            />
          </div>

          <div
            v-if="$store.state.auth.role == 'builder'"
            @click="
              changeCompRouteHandler('addProjects', '/user-profile/add-project')
            "
            style="margin-bottom: 20px"
            class="ChildShowChildTemplate"
          >
            <VsxIcon iconName="Add" :size="32" :color="color" type="linear" />
            <p>ثبت پروژه</p>
            <VsxIcon
              iconName="ArrowLeft"
              :size="20"
              :color="color"
              class="ShowIconK"
              type="linear"
            />
          </div>

          <div
            v-if="$store.state.auth.role == 'builder'"
            @click="
              changeCompRouteHandler('myProjects', '/user-profile/my-projects')
            "
            style="margin-bottom: 20px"
            class="ChildShowChildTemplate"
          >
            <VsxIcon
              iconName="Buildings2"
              :size="32"
              :color="color"
              type="linear"
            />
            <p>پروژه‌های من</p>
            <VsxIcon
              iconName="ArrowLeft"
              :size="20"
              :color="color"
              class="ShowIconK"
              type="linear"
            />
          </div>

          <div
            @click="$router.push('/payment-list')"
            style="margin-bottom: 20px"
            class="ChildShowChildTemplate"
          >
            <VsxIcon
              iconName="Money4"
              :size="32"
              :color="color"
              type="linear"
            />
            <p>پرداخت‌های من</p>
            <VsxIcon
              iconName="ArrowLeft"
              :size="20"
              :color="color"
              class="ShowIconK"
              type="linear"
            />
          </div>

          <div
            @click="
              changeCompRouteHandler(
                'VisitRequest',
                '/user-profile/VisitRequest'
              )
            "
            style="margin-bottom: 20px"
            class="ChildShowChildTemplate"
          >
            <VsxIcon
              iconName="Calendar"
              :size="32"
              :color="color"
              type="linear"
            />
            <p>درخواست های بازدید</p>
            <VsxIcon
              iconName="ArrowLeft"
              :size="20"
              :color="color"
              class="ShowIconK"
              type="linear"
            />
          </div>


          <div
            v-if="$store.state.c_set && $store.state.c_set.tariff_menu"
            @click="
              changeCompRouteHandler(
                'userTariff',
                '/user-profile/userTariff'
              )
            "
            style="margin-bottom: 20px"
            class="ChildShowChildTemplate"
          >
            <VsxIcon
              iconName="ReceiptEdit"
              :size="32"
              :color="color"
              type="linear"
            />
            <p>خرید تعرفه</p>
            <VsxIcon
              iconName="ArrowLeft"
              :size="20"
              :color="color"
              class="ShowIconK"
              type="linear"
            />
          </div>

          <myNotif
            v-if="compType == 'my-notif'"
            @reloadComponnet="user_info_func"
          ></myNotif>
          <create-melk v-if="compType == 'add-file'"></create-melk>
          <builderCreatePost
            v-if="compType == 'add-project'"
          ></builderCreatePost>
          <showProject v-if="compType == 'my-projects'"></showProject>
          <show-file
            v-if="compType == 'my-files'"
            :BranchInfos="branch_infos"
          ></show-file>
          <requestVisit v-if="compType == 'VisitRequest'"></requestVisit>
          <userTariff v-if="compType == 'userTariff'" @tariffSingleBought="getCustomerinfo"></userTariff>
        </div>
      </div>
    </div>
    <div
      @click="profileCloseHandler"
      v-if="ShowModel"
      role="dialog"
      class="j-modal"
      style="--padding-left: 0px; --padding-right: -17px"
    >
      <div @click.stop class="product-modal">
        <header class="product-modal-header">
          <p class="product-modal-header__title">ویرایش پروفایل</p>

          <div
            class="divCreateAdvisorsButton desktopEditBtn"
            v-if="!btn_loading"
            @click="send_edit_data()"
          >
            ویرایش
          </div>
          <div
            class="divCreateAdvisorsButton desktopEditBtn"
            style="cursor: not-allowed"
            v-if="btn_loading"
          >
            <span class="loader"></span>
            <span> ویرایش</span>
          </div>
          <div
            @click="profileCloseHandler"
            role="button"
            class="product-modal-header__close"
          ></div>
        </header>
        <div class="product-modal-content">
          <div class="product-modal-content__container">
            <el-scrollbar :style="editStyle" :max-height="editHeight">
              <div style="margin-bottom: 10px" class="ProfileSetCreate">
                <div id="imageBox" @click="openFileInput">
                  <input
                    type="file"
                    ref="fileInput"
                    accept="image/*"
                    @change="previewImage"
                    style="display: none"
                  />
                  <img
                    v-if="imageSrc"
                    :src="imageSrc"
                    id="imagePreview"
                    :alt="user_info.nickname"
                  />
                  <img
                    v-if="!imageSrc"
                    :src="completeInfos?.avatar"
                    id="imagePreview"
                    :alt="user_info.nickname"
                  />

                  <!-- <button
                    v-if="imageSrc"
                    class="delete-button"
                    @click.stop="removeImage"
                  >
                    <i class="fas fa-trash"></i>
                  </button> -->
                  <button v-if="!imageSrc" class="add-button">
                    <i class="fas fa-plus"></i>
                  </button>
                </div>
                <div class="addPic_text">
                  انتخاب عکس پروفایل
                  <span
                    v-if="$store.state.auth.role != 'customer'"
                    style="color: #f00"
                    >*</span
                  >
                </div>
              </div>

              <div class="ShowInputFormToUser1">
                <div class="ChildShowInputFormToUser">
                  <label>نام<span>*</span></label>
                  <input type="text" maxlength="50" v-model="user_info.fname" />
                </div>
                <div class="ChildShowInputFormToUser">
                  <label>نام خانوادگی<span>*</span></label>
                  <input type="text" maxlength="50" v-model="user_info.lname" />
                </div>
                <div
                  v-if="$store.state.auth.role == 'builder'"
                  class="ChildShowInputFormToUser"
                >
                  <label>نام شرکت</label>
                  <input
                    type="text"
                    maxlength="50"
                    v-model="user_info.company_name"
                  />
                </div>

                <div class="ChildShowInputFormToUser">
                  <label>کد ملی<span>*</span></label>
                  <input
                    type="tel"
                    maxlength="10"
                    inputmode="numeric"
                    v-model="user_info.code_melli"
                  />
                </div>

                <div class="ChildShowInputFormToUser">
                  <label v-if="$store.state.auth.role == 'builder'"
                    >شماره تماس همراه<span>*</span></label
                  >
                  <label v-if="$store.state.auth.role == 'customer'"
                    >شماره تماس <span>*</span></label
                  >
                  <input
                    type="tel"
                    maxlength="11"
                    inputmode="numeric"
                    v-model="user_info.mobile"
                    disabled
                  />
                </div>

                <div
                  v-if="$store.state.auth.role == 'builder'"
                  class="ChildShowInputFormToUser"
                >
                  <label>شماره تماس دفتر</label>
                  <input
                    type="tel"
                    maxlength="11"
                    inputmode="numeric"
                    v-model="user_info.phone"
                  />
                </div>

                <div
                  v-if="$store.state.auth.role == 'builder'"
                  class="ChildShowInputFormToUser"
                >
                  <label>آدرس دفتر کار<span>*</span></label>
                  <input
                    type="text"
                    maxlength="50"
                    v-model="user_info.address"
                  />
                </div>

                <div
                  v-if="$store.state.auth.role == 'builder'"
                  class="ChildShowInputFormToUser"
                >
                  <label>منطقه فعالیت<span>*</span></label>
                  <el-select
                    v-model="user_info.category_id"
                    multiple
                    collapse-tags
                    collapse-tags-tooltip
                    placeholder=""
                  >
                    <el-option
                      v-for="(v, i) in district_list"
                      :key="i"
                      :value="v.id"
                      :label="v.title"
                    >
                    </el-option>
                  </el-select>
                </div>

                <div
                  v-if="$store.state.auth.role == 'builder'"
                  class="ChildShowInputFormToUser activityType"
                >
                  <label>نوع فعالیت</label>
                  <div class="activityOptionsList">
                    <div class="listWrapper">
                      <div class="listThumb">
                        <input
                          type="checkbox"
                          id="aprtment"
                          value="apartment"
                          :checked="
                            user_info.b_activity_type.includes('apartment')
                          "
                          @change="handleCheckboxChange($event, 'apartment')"
                          class="hiddenInput"
                        />
                        <label for="aprtment" class="filterListInput">
                          <div
                            class="customCheckBox"
                            :class="{
                              checked:
                                user_info.b_activity_type.includes('apartment'),
                            }"
                          >
                            <div class="checkedTick">
                              <i class="fa-solid fa-check"></i>
                            </div>
                          </div>
                        </label>
                        <label for="aprtment" class="filterListTitle">
                          آپارتمان سازی
                        </label>
                      </div>
                      <div class="listThumb">
                        <input
                          type="checkbox"
                          id="villa"
                          value="villa"
                          :checked="user_info.b_activity_type.includes('villa')"
                          @change="handleCheckboxChange($event, 'villa')"
                          class="hiddenInput"
                        />
                        <label for="villa" class="filterListInput">
                          <div
                            class="customCheckBox"
                            :class="{
                              checked:
                                user_info.b_activity_type.includes('villa'),
                            }"
                          >
                            <div class="checkedTick">
                              <i class="fa-solid fa-check"></i>
                            </div>
                          </div>
                        </label>
                        <label for="villa" class="filterListTitle">
                          ویلا سازی
                        </label>
                      </div>
                      <div class="listThumb">
                        <input
                          type="checkbox"
                          id="commercial"
                          value="commercial"
                          :checked="
                            user_info.b_activity_type.includes('commercial')
                          "
                          @change="handleCheckboxChange($event, 'commercial')"
                          class="hiddenInput"
                        />
                        <label for="commercial" class="filterListInput">
                          <div
                            class="customCheckBox"
                            :class="{
                              checked:
                                user_info.b_activity_type.includes(
                                  'commercial'
                                ),
                            }"
                          >
                            <div class="checkedTick">
                              <i class="fa-solid fa-check"></i>
                            </div>
                          </div>
                        </label>
                        <label for="commercial" class="filterListTitle">
                          تجاری سازی
                        </label>
                      </div>
                      <div class="listThumb">
                        <input
                          type="checkbox"
                          id="rebuild"
                          value="rebuild"
                          :checked="
                            user_info.b_activity_type.includes('rebuild')
                          "
                          @change="handleCheckboxChange($event, 'rebuild')"
                          class="hiddenInput"
                        />
                        <label for="rebuild" class="filterListInput">
                          <div
                            class="customCheckBox"
                            :class="{
                              checked:
                                user_info.b_activity_type.includes('rebuild'),
                            }"
                          >
                            <div class="checkedTick">
                              <i class="fa-solid fa-check"></i>
                            </div>
                          </div>
                        </label>
                        <label for="rebuild" class="filterListTitle">
                          بازسازی
                        </label>
                      </div>
                      <div class="listThumb">
                        <input
                          type="checkbox"
                          id="other"
                          value="other"
                          :checked="user_info.b_activity_type.includes('other')"
                          @change="handleCheckboxChange($event, 'other')"
                          class="hiddenInput"
                        />
                        <label for="other" class="filterListInput">
                          <div
                            class="customCheckBox"
                            :class="{
                              checked:
                                user_info.b_activity_type.includes('other'),
                            }"
                          >
                            <div class="checkedTick">
                              <i class="fa-solid fa-check"></i>
                            </div>
                          </div>
                        </label>
                        <label for="other" class="filterListTitle">
                          سایر
                        </label>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  v-if="$store.state.auth.role == 'builder'"
                  class="ChildShowInputFormToUser activityType"
                >
                  <label>سال شروع فعالیت</label>

                  <el-select placeholder="" v-model="user_info.work_history">
                    <el-option
                      v-for="(year, index) in years"
                      :key="index"
                      :label="year"
                      :value="year"
                    />
                    <el-option :value="'before'" :label="'قبل از سال 1370'" />
                  </el-select>
                </div>

                <div
                  v-if="$store.state.auth.role == 'builder'"
                  class="ChildShowInputFormToUser activityType"
                >
                  <label>درباره من</label>
                  <textarea v-model="user_info.description" rows="2"></textarea>
                </div>

                <div
                  v-if="$store.state.auth.role == 'builder'"
                  class="ChildShowInputFormToUser"
                >
                  <label>آدرس تلگرام</label>
                  <input
                    type="text"
                    maxlength="50"
                    v-model="user_info.telegram"
                  />
                </div>

                <div
                  v-if="$store.state.auth.role == 'builder'"
                  class="ChildShowInputFormToUser"
                >
                  <label>آدرس واتس اپ</label>
                  <input
                    type="text"
                    maxlength="50"
                    v-model="user_info.whats_app"
                  />
                </div>

                <div
                  v-if="$store.state.auth.role == 'builder'"
                  class="ChildShowInputFormToUser"
                >
                  <label>آدرس اینستاگرام</label>
                  <input type="text" maxlength="50" v-model="user_info.insta" />
                </div>
                <div class="resProfileEditBtn" @click="send_edit_data">
                  <span v-if="!btn_loading">ویرایش</span>
                  <span v-if="btn_loading" class="loader"></span>
                </div>
              </div>
            </el-scrollbar>
          </div>
        </div>
      </div>
      <div class="j-modal__overly"></div>
    </div>

    <el-dialog
      v-model="showFollowed"
      align-center
      class="followListDialog"
      @close="selectedFollowClose"
    >
      <div class="followedList">
        <div class="followListNav">
          <div class="navTitle">
            <span v-if="selectedFollow == 'follower'">دنبال کنندگان</span>
            <span v-if="selectedFollow == 'following'">دنبال شوندگان</span>
          </div>
          <div class="navBackBtn">
            <div class="backBtn" @click="selectedFollowClose(true)">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                class="size-6"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M6 18 18 6M6 6l12 12"
                />
              </svg>
            </div>
          </div>
        </div>
        <div class="followedListWrapper">
          <div class="headerWrapper">
            <div
              class="listHeader"
              :class="[selectedFollow == 'follower' ? 'follower' : 'following']"
            >
              <div class="headerSwitch"></div>
              <div
                class="headerBtn follower"
                :class="{ selected: selectedFollow == 'follower' }"
                @click="selectedFollowHandler('follower')"
              >
                دنبال کنندگان
              </div>
              <div
                class="headerBtn following"
                :class="{ selected: selectedFollow == 'following' }"
                @click="selectedFollowHandler('following')"
              >
                دنبال شوندگان
              </div>
            </div>
          </div>
          <div class="listContent">
            <!--            following-->
            <el-scrollbar
              v-if="selectedFollow == 'following'"
              ref="usersList"
              class="usersList followingList"
              :height="followListHeight"
            >
              <div v-if="following.loading && following.list.length === 0">
                <div v-for="n in 3" :key="n" class="skeleton-wrapper">
                  <div class="TopShowToUSerNAme">
                    <div class="ImageTopShowToUSerNAme"></div>
                    <div
                      class="titleTopShowToUSerNAme"
                      style="width: 90%"
                    ></div>
                  </div>
                </div>
              </div>

              <div v-if="!following.loading && following.list.length > 0">
                <div
                  class="userThumb"
                  v-for="(v, i) in following.list"
                  :key="i"
                  @click="profileRouteHandler(v)"
                >
                  <div class="userInfo">
                    <div class="userProfile">
                      <img :src="v.avatar" alt="" />
                    </div>
                    <div class="userName">{{ v.nickname }}</div>
                  </div>
                  <!-- <div
                    class="userBtn"
                    v-if="
                      userInforamtion &&
                      userInforamtion.uid != v.uid &&
                      user_info.uid == $store.state.auth.uid
                    "
                  >

                    <div
                      class="followBtn"
                      style="padding: 0"
                      v-if="follow_btn_loading[i]"
                    >
                      <span
                        class="loader"
                        style="width: 18px !important; height: 18px !important"
                      ></span>
                    </div>
                  </div> -->

                  <div
                    class="userBtn"
                    v-if="userInforamtion && userInforamtion.uid != v.uid"
                  >
                    <div
                      class="followBtn"
                      v-if="!v.isfollower && !follow_btn_loading[i]"
                      @click.stop="
                        follow_list_btn(v.uid, i, 'follow', 'following')
                      "
                    >
                      دنبال کردن
                    </div>
                    <div
                      class="followBtn"
                      style="padding: 0"
                      v-if="follow_btn_loading[i]"
                    >
                      <span
                        class="loader"
                        style="width: 18px !important; height: 18px !important"
                      ></span>
                    </div>
                    <div
                      class="followBtn unfollowBtn"
                      v-if="!follow_btn_loading[i] && v.isfollower"
                      @click.stop="
                        follow_list_btn(v.uid, i, 'unfollow', 'following')
                      "
                    >
                      لغو دنبال کردن
                    </div>
                  </div>
                </div>
              </div>

              <div
                v-if="following.list.length === 0 && !following.loading"
                class="no-result"
              >
                <p>دنبال شونده ای یافت نشد</p>
              </div>

              <!-- Loading indicator برای lazy loading -->
              <div v-if="following.lazyLoading" class="lazy-loading-indicator">
                <div class="loading-spinner"></div>
                <p>در حال بارگذاری...</p>
              </div>
            </el-scrollbar>

            <!--            follower-->
            <el-scrollbar
              v-if="selectedFollow == 'follower'"
              id="usersList"
              class="usersList followerList"
              :height="followListHeight"
            >
              <div v-if="follower.loading && follower.list.length === 0">
                <!--              <div >-->
                <div v-for="n in 10" :key="n" class="skeleton-wrapper">
                  <div class="TopShowToUSerNAme">
                    <div class="ImageTopShowToUSerNAme"></div>
                    <div
                      class="titleTopShowToUSerNAme"
                      style="width: 90%"
                    ></div>
                  </div>
                </div>
              </div>

              <div v-if="!follower.loading && follower.list.length > 0">
                <div
                  class="userThumb"
                  v-for="(v, i) in follower.list"
                  :key="i"
                  @click="profileRouteHandler(v)"
                >
                  <div class="userInfo">
                    <div class="userProfile">
                      <img :src="v.avatar" alt="" />
                    </div>
                    <div class="userName">{{ v.nickname }}</div>
                  </div>
                  <div
                    class="userBtn"
                    v-if="userInforamtion && userInforamtion.uid != v.uid"
                  >
                    <div
                      class="followBtn"
                      v-if="!v.isfollowing && !follow_btn_loading[i]"
                      @click.stop="follow_list_btn(v.uid, i, 'follow')"
                    >
                      دنبال کردن
                    </div>
                    <div
                      class="followBtn"
                      style="padding: 0"
                      v-if="follow_btn_loading[i]"
                    >
                      <span
                        class="loader"
                        style="width: 18px !important; height: 18px !important"
                      ></span>
                    </div>
                    <div
                      class="followBtn unfollowBtn"
                      v-if="!follow_btn_loading[i] && v.isfollowing"
                      @click.stop="follow_list_btn(v.uid, i, 'unfollow')"
                    >
                      لغو دنبال کردن
                    </div>
                  </div>
                </div>
              </div>

              <div
                v-if="follower.list.length === 0 && !follower.loading"
                class="no-result"
              >
                <p>دنبال کننده ای یافت نشد</p>
              </div>

              <!-- Loading indicator برای lazy loading -->
              <div v-if="follower.lazyLoading" class="lazy-loading-indicator">
                <div class="loading-spinner"></div>
                <p>در حال بارگذاری...</p>
              </div>
            </el-scrollbar>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import CreateMelk from "@/components/profile/createMelk";
import ShowFile from "@/components/profile/ShowFile";
import { Skeletor } from "vue-skeletor";
import { toast } from "vue3-toastify";
import "vue3-toastify/dist/index.css";
// import Compressor from "compressorjs";
import axios from "axios";
import myNotif from "@/components/profile/myNotif.vue";
import builderCreatePost from "./builderCreatePost.vue";
import showProject from "@/components/profile/showProjects.vue";
import requestVisit from "@/components/profile/requestVisit.vue";
import userTariff from "@/components/profile/userTariff.vue";

export default {
  name: "amlakProfile",
  components: {
    ShowFile,
    CreateMelk,
    builderCreatePost,
    Skeletor,
    myNotif,
    showProject,
    requestVisit,
    userTariff
  },
  data() {
    return {
      isLoading: true,
      followListHeight: "50vh",
      userInforamtion: null,
      selectedFollow: "",
      isFilterOpen: false,
      newStory: false,
      isBackAction: false,
      left_menu: {
        CreateMelk: false,
        ShowFile: false,
        myNotif: false,
        createPost: false,
        userTariff: false,
      },
      compOpen: false,
      btn_loading: false,
      ShowModel: false,
      LoadingSkeleton: true,
      color: "",
      isDialogOpen: false,
      follower: {
        hasMorePages: true,
        lazyLoading: false,
        loading: true,
        page: 1,
        list: [],
        LoadingSkeleton: true,
      },
      following: {
        hasMorePages: true,
        lazyLoading: false,
        loading: true,
        page: 1,
        list: [],
        LoadingSkeleton: true,
      },
      follow_btn_loading: [],
      scrollEl: null,
      editStyle: "padding: 0 30px; padding-bottom: 30px;",
      editHeight: "70vh",
      completeInfos: null,
      user_info: {
        avatar: "",
        uid: "",
        role: "builder",
        fname: "",
        lname: "",
        company_name: "",
        mobile: "",
        code_melli: "",
        address: "",
        phone: "",
        category_id: [],
        b_activity_type: [],
        work_history: "",
        description: "",
        telegram: "",
        whats_app: "",
        insta: "",
      },
      years: [],
      district_list: [],
      imageSrc: null,
      avatarFile: null,
      visitStatChecked: false,
      requestStatLaoing: false,
    };
  },
  computed: {
    showFollowed() {
      return this.selectedFollow !== "";
    },
    compType() {
      const routeType = this.$route.params.comp;
      return routeType || "";
    },
  },
  methods: {
    handleToggle() {
      const toggleValue = this.visitStatChecked ? 1 : 0;
      this.requestStatLaoing = true;
      this.helperPost("change-visit-request", {
        request_visit: toggleValue,
      })
        .then((response) => {
          console.log(response);
          if (toggleValue == 1) {
            toast("امکان ثبت درخواست بازدید برای آگهی های شما فعال شد", {
              type: "success",
            });
          } else {
            toast("امکان ثبت درخواست بازدید برای آگهی های شما غیرفعال شد", {
              type: "success",
            });
            this.visitStatChecked = false;
          }
          this.requestStatLaoing = false;
        })
        .catch((error) => {
          console.error(error);
          toast("مشکلی پیش آمده؛ مجددا امتحان کنید.", { type: "error" });
          this.visitStatChecked = false; // به جای $refs
          this.requestStatLaoing = false;
        });
    },
    editStyleHandler() {
      let windowWidth = window.innerWidth;
      if (windowWidth < 700) {
        this.editStyle = "padding: 0 16px; padding-bottom: 24px;";
        this.editHeight = "90vh";
      }
    },
    handleFollowHeight() {
      let windowWidth = window.innerWidth;
      if (windowWidth < 700) {
        this.followListHeight = "calc(100vh - 150px)";
      }
    },
    follow(target_id, i, state) {
      var user_id = this.$store.state.auth.uid;
      this.follow_btn_loading[i] = true;
      this.helperPost("follow", {
        uid: user_id,
        target_id: target_id,
      }).then((r) => {
        console.log(r);
        if (state == "unfollow") {
          this.following.list.splice(i, 1);
          this.$store.state.auth.following--;
          this.follower.list[i].isfollowing = 0;
        } else {
          this.follower.list[i].isfollowing = 1;
          this.$store.state.auth.following++;
        }
        this.follow_btn_loading[i] = false;
        this.getCustomerinfo();
      });
    },
    load_district() {
      let self = this;
      this.helperGet("system-cat", "type=builder").then((r) => {
        console.log("datattt:" + r.data.data);
        self.district_list = r.data.data;
      });
    },
    // handleScroll() {
    //   const scrollbar = document.querySelector(".usersList");
    //   if (
    //     !scrollbar ||
    //     this.follower.lazyLoading ||
    //     !this.follower.hasMorePages
    //   )
    //     return;

    //   const scrollPosition = scrollbar.scrollTop + scrollbar.clientHeight;
    //   const scrollHeight = scrollbar.scrollHeight;

    //   if (scrollPosition >= scrollHeight * 0.9) {
    //     this.loadMore();
    //   }
    // },
    handleScroll(e) {
      const target = e.target;
      let currentState =
        this.selectedFollow === "follower" ? this.follower : this.following;

      if (!target || currentState.lazyLoading || !currentState.hasMorePages)
        return;

      const scrollPosition = target.scrollTop + target.clientHeight;
      const scrollHeight = target.scrollHeight;

      if (scrollPosition >= scrollHeight - 10) {
        if (this.selectedFollow === "follower") {
          this.loadMoreFollower();
        } else {
          this.loadMoreFollowing();
        }
      }
    },

    async loadMoreFollower() {
      if (this.follower.hasMorePages && !this.follower.lazyLoading) {
        this.follower.lazyLoading = true;
        this.follower.page++;
        await this.getfollower();
        this.follower.lazyLoading = false;
      }
    },

    async loadMoreFollowing() {
      if (this.following.hasMorePages && !this.following.lazyLoading) {
        this.following.lazyLoading = true;
        this.following.page++;
        await this.getfollowing();
        this.following.lazyLoading = false;
      }
    },

    attachScrollEvent() {
      this.$nextTick(() => {
        // ابتدا event قبلی رو detach کن
        this.detachScrollEvent();

        let selector =
          this.selectedFollow === "follower"
            ? ".followerList .el-scrollbar__wrap"
            : ".followingList .el-scrollbar__wrap";

        const el = this.$el.querySelector(selector);
        if (el) {
          this.scrollEl = el;
          el.addEventListener("scroll", this.handleScroll);
        }
      });
    },

    detachScrollEvent() {
      if (this.scrollEl) {
        this.scrollEl.removeEventListener("scroll", this.handleScroll);
        this.scrollEl = null;
      }
    },

    // async loadMore() {
    //   if (this.follower.hasMorePages && !this.follower.lazyLoading) {
    //     this.follower.lazyLoading = true;
    //     this.follower.page++;
    //     await this.getfollower();
    //     this.follower.lazyLoading = false;
    //   }
    // },
    getfollower: function () {
      let self = this;
      // فقط برای صفحه اول loading رو true کن
      if (self.follower.page === 1) {
        this.follower.loading = true;
      }
      self.follower.hasMorePages = false;
      // این خط رو حذف کردیم که باعث پاک شدن لیست میشد
      // self.following.list = [];
      this.helperPost("followers-list", { page: self.follower.page })
        .then(function (r) {
          const result = r.data;
          if (result.result === "1") {
            const list = result.data.list;
            const totalPage = parseInt(result.data.total_page);
            const currentPage = parseInt(self.follower.page);
            if (currentPage > 1) {
              // برای صفحات بعدی، لیست رو به انتهای لیست موجود اضافه کن
              self.follower.list = [...self.follower.list, ...list];
            } else {
              // فقط برای صفحه اول، لیست رو جایگزین کن
              const scrollbar = document.querySelector(".usersList");
              if (scrollbar) scrollbar.scrollTop = 0;
              self.follower.list = list;
            }

            self.follow_btn_loading = new Array(self.follower.list.length).fill(
              false
            );

            self.follower.hasMorePages = currentPage < totalPage;
          } else {
            self.follower.hasMorePages = false;
          }
          self.follower.loading = false;

          console.log("self.follower.list", self.follower.list);
        })
        .catch(function (err) {
          console.error("Error loading orders:", err);
          self.follower.loading = false;
          self.follower.hasMorePages = false;
        });
    },

    getfollowing: function () {
      let self = this;
      // فقط برای صفحه اول loading رو true کن
      if (self.following.page === 1) {
        this.following.loading = true;
      }
      self.following.hasMorePages = false;
      // این خط رو حذف کردیم که باعث پاک شدن لیست میشد
      // self.follower.list = [];
      this.helperPost("following-list", { page: self.following.page })
        .then(function (r) {
          const result = r.data;
          console.log("result", result);
          if (result.result === "1") {
            const list = result.data.list;
            const totalPage = parseInt(result.data.total_page);
            const currentPage = parseInt(self.following.page);
            console.log("ist0", list);
            if (currentPage > 1) {
              console.log("ist1", list);
              // برای صفحات بعدی، لیست رو به انتهای لیست موجود اضافه کن
              self.following.list = [...self.following.list, ...list];
            } else {
              // فقط برای صفحه اول، لیست رو جایگزین کن
              const scrollbar = document.querySelector(".usersList");
              if (scrollbar) scrollbar.scrollTop = 0;

              console.log("ist", list);
              self.following.list = list;
            }

            self.follow_btn_loading = new Array(
              self.following.list.length
            ).fill(false);

            self.following.hasMorePages = currentPage < totalPage;
          } else {
            self.following.hasMorePages = false;
          }
          self.following.loading = false;

          console.log("self.following.list", self.following.list);
        })
        .catch(function (err) {
          console.error("Error loading orders:", err);
          self.following.loading = false;
          self.following.hasMorePages = false;
        });
    },

    selectedFollowClose(btn = false) {
      let self = this;
      if (!this.isBackAction && btn) {
        history.back();
      }

      setTimeout(() => {
        // Reset کردن همه state ها
        self.follower.list = [];
        self.following.list = [];
        self.follower.page = 1;
        self.following.page = 1;
        self.follower.hasMorePages = true;
        self.following.hasMorePages = true;
        self.follower.loading = false;
        self.following.loading = false;
        self.follower.lazyLoading = false;
        self.following.lazyLoading = false;
        self.selectedFollow = "";
      }, 500);
    },
    selectedFollowHandler(state, first = false) {
      this.selectedFollow = state;
      if (first) {
        history.pushState(null, "", location.href);
      }
      // API فراخوانی رو حذف کردیم چون در watch انجام میشه
    },
    profileRouteHandler(user) {
      if (user.role == "branch_admin") {
        this.$router.push({
          path: "/profile-amlak",
          query: { bid: user.branch_id },
        });
      } else if (user.role == "builder") {
        this.$router.push({
          path: "/profile-builder",
          query: { uid: user.uid },
        });
      } else
        this.$router.push({
          path: "/profile-superior",
          query: { uid: user.uid },
        });
    },
    loadTheme() {
      const width = window.innerWidth;
      this.color = width >= 1250 ? "#0096c7" : "#f5f5f5";
    },
    checkDocumentReady() {
      return new Promise((resolve) => {
        if (document.readyState === "complete") {
          resolve();
        } else {
          window.addEventListener("load", resolve, { once: true });
        }
      });
    },
    openFileInput() {
      this.$refs.fileInput.click();
    },
    // async previewImage(event) {
    //   var self = this;
    //   const file = event.target.files[0];
    //   if (!file) {
    //     return;
    //   }
    //   const reader = new FileReader();
    //   reader.onload = (e) => {
    //     this.imageSrc = e.target.result;
    //   };
    //   reader.readAsDataURL(file);

    //   new Compressor(file, {
    //     quality: 0.6,

    //     // The compression process is asynchronous,
    //     // which means you have to access the `result` in the `success` hook function.
    //     success(result) {
    //       const formData = new FormData();

    //       // The third parameter is required for server
    //       formData.append("avatar", result, result.name);
    //       formData.append("uid", self.$store.state.auth.uid);

    //       axios
    //         .post(self.$store.getters.baseUrl + "/upload-avatar", formData, {
    //           headers: {
    //             "Content-Type": "multipart/form-data", // Set the content type for file upload
    //             Authorization: "Bearer " + self.$store.getters.appToken,
    //           },
    //         })
    //         .then(function (response) {
    //           console.log("response", response);
    //           if (response.data.result == "1") {
    //             toast(response.data.msg, {
    //               type: "success",
    //               dangerouslyHTMLString: true,
    //             });
    //             self.user_info_func("first");
    //             self.ShowModel = false;
    //           } else {
    //             toast("اشکال در ثبت رخ داد!دوباره تلاش کنید", {
    //               type: "error",
    //               dangerouslyHTMLString: true,
    //             });
    //           }
    //         });
    //     },
    //     error(err) {
    //       console.log(err.message);
    //     },
    //   });
    // },
    previewImage(event) {
      const file = event.target.files[0];
      if (!file) return;

      this.avatarFile = file; // فایل رو نگه می‌داریم
      const reader = new FileReader();
      reader.onload = (e) => {
        this.imageSrc = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    // removeImage() {
    //   var self = this;
    //   self.imageSrc = null;
    //   self.$refs.fileInput.value = "";
    //   self.$swal
    //     .fire({
    //       title: "حذف تصویر پروفایل",
    //       text: "آیا از حذف تصویر پروفایل مطمئن هستید؟",
    //       icon: "warning",
    //       showCancelButton: true,
    //       confirmButtonColor: "#0096c7",
    //       cancelButtonColor: "#fff",
    //       confirmButtonText: "بله مطمئنم",
    //       cancelButtonText: "لغو",
    //     })
    //     .then((result) => {
    //       if (result.isConfirmed) {
    //         if (result.value) {
    //           self
    //             .helperGet("delete-avatar", "uid=" + this.$store.state.auth.uid)
    //             .then((r) => {
    //               if (r.data.result == "1") {
    //                 toast(r.data.msg, {
    //                   type: "success",
    //                   dangerouslyHTMLString: true,
    //                 });
    //                 self.imageSrc = null;
    //                 self.$refs.fileInput.value = "";
    //                 self.user_info_func("first");
    //                 self.ShowModel = false;
    //               }
    //             });
    //         }
    //       }
    //     });
    // },
    removeImage() {
      this.avatarFile = null;
      this.imageSrc = null;
      this.user_info.avatar = ""; // حذف کامل
      this.$refs.fileInput.value = "";
    },
    Logout() {
      this.$swal
        .fire({
          title: "خروج از حساب کاربری",
          text: "آیا مطمئن هستید که می خواهید از حساب خود خارج شوید؟",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#0096c7",
          cancelButtonColor: "#fff",
          confirmButtonText: "خروج",
          cancelButtonText: "انصراف",
        })
        .then((result) => {
          if (result.isConfirmed) {
            if (result.value) {
              let self = this;
              this.helperPost("logout")
                .then((r) => {
                  if (r.data.success == true) {
                    this.$store.state._token = "";
                    this.$store.getters.auth.loggedIn = false;
                    // this.$store.state.c_set = [];
                    localStorage.removeItem("_token");
                    localStorage.removeItem("auth");
                    this.$router.push({ path: "/home" });
                  }
                })
                .catch(function () {
                  self.loading = false;
                });
            }
          }
        });
    },

    // send_edit_data() {
    //   if (this.user_info.avatar == "") {
    //     toast("تصویر پروفایل خود را آپلود کنید", {
    //       type: "error",
    //     });
    //     return;
    //   } else if (this.user_info.fname == "") {
    //     toast("نام خود را وارد کنید", {
    //       type: "error",
    //     });
    //     return;
    //   } else if (this.user_info.lname == "") {
    //     toast("نام خانوادگی خود را وارد کنید", {
    //       type: "error",
    //     });
    //     return;
    //   }  else if (this.user_info.code_melli == "") {
    //     toast("کد ملی خود را وارد کنید", {
    //       type: "error",
    //     });
    //     return;
    //   } else if (this.user_info.category_id == "" && this.$store.state.auth.role != 'consultant') {
    //     toast("منطقه قعالیت خود را انتخاب کنید", {
    //       type: "error",
    //     });
    //     return;
    //   } else if (this.user_info.mobile == "" && this.$store.state.auth.role != 'consultant') {
    //     toast("شماره تماس خود را وارد کنید", {
    //       type: "error",
    //     });
    //     return;
    //   } else if (this.user_info.address == "" && this.$store.state.auth.role != 'consultant') {
    //     toast("آدرس دفتر کار خود را وارد کنید", {
    //       type: "error",
    //     });
    //     return;
    //   }
    //   this.btn_loading = true;
    //   this.helperPost("update-profile", this.user_info).then((r) => {
    //     console.log("sdsd", r);
    //     if (r.data.result == "1") {
    //       toast(r.data.msg, {
    //         type: "success",
    //         dangerouslyHTMLString: true,
    //       });
    //       this.user_info_func();
    //       this.getCustomerinfo();
    //       this.ShowModel = false;
    //     } else {
    //       toast("اشکال در ثبت رخ داد!دوباره تلاش کنید", {
    //         type: "error",
    //         dangerouslyHTMLString: true,
    //       });
    //     }
    //     this.btn_loading = false;
    //   });
    // },

    async send_edit_data() {
      // ولیدیشن
      if (
        !this.avatarFile &&
        !this.user_info.avatar &&
        this.$store.state.auth.role != "customer"
      ) {
        toast("تصویر پروفایل خود را آپلود کنید", { type: "error" });
        return;
      } else if (!this.user_info.fname) {
        toast("نام خود را وارد کنید", { type: "error" });
        return;
      } else if (!this.user_info.lname) {
        toast("نام خانوادگی خود را وارد کنید", { type: "error" });
        return;
      } else if (!this.user_info.code_melli) {
        toast("کد ملی خود را وارد کنید", { type: "error" });
        return;
      } else if (
        this.user_info.category_id == "" &&
        this.$store.state.auth.role != "customer"
      ) {
        toast("منطقه فعالیت خود را انتخاب کنید", { type: "error" });
        return;
      } else if (
        !this.user_info.mobile &&
        this.$store.state.auth.role != "consultant"
      ) {
        toast("شماره تماس خود را وارد کنید", { type: "error" });
        return;
      } else if (
        !this.user_info.address &&
        this.$store.state.auth.role != "customer"
      ) {
        toast("آدرس دفتر کار خود را وارد کنید", { type: "error" });
        return;
      }

      this.btn_loading = true;

      try {
        if (this.avatarFile) {
          // const compressed = await new Promise((resolve, reject) => {
          //   new Compressor(this.avatarFile, {
          //     quality: 0.6,
          //     success: (result) => resolve(result),
          //     error: (err) => reject(err),
          //   });
          // });

          const formData = new FormData();
          formData.append("avatar", this.avatarFile, this.avatarFile.name);
          formData.append("uid", this.$store.state.auth.uid);

          const avatarRes = await axios.post(
            this.$store.getters.baseUrl + "/upload-avatar",
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
                Authorization: "Bearer " + this.$store.getters.appToken,
              },
            }
          );

          if (avatarRes.data.result == "1") {
            this.user_info.avatar = avatarRes.data.avatar_url;
          } else {
            toast("آپلود تصویر پروفایل با مشکل مواجه شد", { type: "error" });
            this.btn_loading = false;
            return;
          }
        }

        // حالا پروفایل رو آپدیت کن
        const r = await this.helperPost("update-profile", this.user_info);

        if (r.data.result == "1") {
          toast(r.data.msg, {
            type: "success",
            dangerouslyHTMLString: true,
          });
          this.user_info_func();
          this.getCustomerinfo();
          this.ShowModel = false;
        } else {
          toast("اشکال در ثبت رخ داد! دوباره تلاش کنید", {
            type: "error",
            dangerouslyHTMLString: true,
          });
        }
      } catch (error) {
        console.error(error);
        toast("خطایی در ارتباط با سرور رخ داد", { type: "error" });
      } finally {
        this.btn_loading = false;
      }
    },

    profileEditHadler() {
      let windowWidth = window.innerWidth;
      if (windowWidth < 700) {
        history.pushState(null, "", location.href);
      }
      this.ShowModel = true;
    },

    profileCloseHandler() {
      let windowWidth = window.innerWidth;
      if (windowWidth < 700) {
        history.back();
      }
      this.ShowModel = false;
    },
    changeCompRouteHandler(routeName, route) {
      if (routeName == "addFiles") {
        console.log("menuKey == 'createMelk'");
        if (!this.$store.state.auth.loggedIn) {
          toast("برای ثبت آگهی وارد حساب کاربری خود شوید", {
            type: "error",
          });
          return;
        }
        if (this.$store.state.auth.role == "customer") {
          if (
            this.$store.state.auth.loggedIn &&
            !this.$store.state.auth.is_complate
          ) {
            toast("برای ثبت آگهی اطلاعات پروفایل خود را تکمیل کنید", {
              type: "error",
            });
            return;
          }
        } else if (this.$store.state.auth.role == "builder") {
          if (
            this.$store.state.auth.loggedIn &&
            !this.$store.state.auth.is_complate
          ) {
            toast("برای ثبت آگهی اطلاعات پروفایل خود را تکمیل کنید", {
              type: "error",
            });
            return;
          }
          if (
            this.$store.state.auth.loggedIn &&
            this.$store.state.auth.is_complate &&
            this.$store.state.auth.is_allowed == "no"
          ) {
            toast(
              "پروفایل شما تکمیل شده است، اما برای ثبت آگهی نیاز است هویت شما تایید شود.",
              {
                type: "error",
              }
            );
            return;
          }
        }
      }
      if (routeName == "addProjects") {
        if (!this.$store.state.auth.loggedIn) {
          toast("برای ثبت پروژه وارد حساب کاربری خود شوید", {
            type: "error",
          });
          return;
        }
        if (this.$store.state.auth.role == "customer") {
          if (
            this.$store.state.auth.loggedIn &&
            !this.$store.state.auth.is_complate
          ) {
            toast("برای ثبت پروژه اطلاعات پروفایل خود را تکمیل کنید", {
              type: "error",
            });
            return;
          }
        } else if (this.$store.state.auth.role == "builder") {
          if (
            this.$store.state.auth.loggedIn &&
            !this.$store.state.auth.is_complate
          ) {
            toast("برای ثبت پروژه اطلاعات پروفایل خود را تکمیل کنید", {
              type: "error",
            });
            return;
          }
          if (
            this.$store.state.auth.loggedIn &&
            this.$store.state.auth.is_complate &&
            this.$store.state.auth.is_allowed == "no"
          ) {
            toast(
              "پروفایل شما تکمیل شده است، اما برای ثبت پروژه نیاز است هویت شما تایید شود.",
              {
                type: "error",
              }
            );
            return;
          }
        }
      }
      if (routeName == "myAds") {
        if (!this.$store.state.auth.loggedIn) {
          toast("برای مشاهده لیست آگهی‌ها وارد حساب کاربری خود شوید", {
            type: "error",
          });
          return;
        }
        if (this.$store.state.auth.role == "customer") {
          if (
            this.$store.state.auth.loggedIn &&
            !this.$store.state.auth.is_complate
          ) {
            toast(
              "برای مشاهده لیست آگهی‌ها اطلاعات پروفایل خود را تکمیل کنید",
              {
                type: "error",
              }
            );
            return;
          }
        } else if (this.$store.state.auth.role == "builder") {
          if (
            this.$store.state.auth.loggedIn &&
            !this.$store.state.auth.is_complate
          ) {
            toast(
              "برای مشاهده لیست آگهی‌ها اطلاعات پروفایل خود را تکمیل کنید",
              {
                type: "error",
              }
            );
            return;
          }
          if (
            this.$store.state.auth.loggedIn &&
            this.$store.state.auth.is_complate &&
            this.$store.state.auth.is_allowed == "no"
          ) {
            toast(
              "پروفایل شما تکمیل شده است، اما برای مشاهده لیست آگهی‌ها نیاز است هویت شما تایید شود.",
              {
                type: "error",
              }
            );
            return;
          }
        }
      }
      if (routeName == "myProjects") {
        if (!this.$store.state.auth.loggedIn) {
          toast("برای مشاهده لیست پروژه‌ها وارد حساب کاربری خود شوید", {
            type: "error",
          });
          return;
        }
        if (this.$store.state.auth.role == "customer") {
          if (
            this.$store.state.auth.loggedIn &&
            !this.$store.state.auth.is_complate
          ) {
            toast(
              "برای مشاهده لیست پروژه‌ها اطلاعات پروفایل خود را تکمیل کنید",
              {
                type: "error",
              }
            );
            return;
          }
        } else if (this.$store.state.auth.role == "builder") {
          if (
            this.$store.state.auth.loggedIn &&
            !this.$store.state.auth.is_complate
          ) {
            toast(
              "برای مشاهده لیست پروژه‌ها اطلاعات پروفایل خود را تکمیل کنید",
              {
                type: "error",
              }
            );
            return;
          }
          if (
            this.$store.state.auth.loggedIn &&
            this.$store.state.auth.is_complate &&
            this.$store.state.auth.is_allowed == "no"
          ) {
            toast(
              "پروفایل شما تکمیل شده است، اما برای مشاهده لیست پروژه‌ها نیاز است هویت شما تایید شود.",
              {
                type: "error",
              }
            );
            return;
          }
        }
      }
      if (routeName == "userTariff") {
        if (!this.$store.state.auth.loggedIn) {
          toast("برای خرید تعرفه وارد حساب کاربری خود شوید", {
            type: "error",
          });
          return;
        }
        if (this.$store.state.auth.role == "customer") {
          if (
            this.$store.state.auth.loggedIn &&
            !this.$store.state.auth.is_complate
          ) {
            toast(
              "برای خرید تعرفه اطلاعات پروفایل خود را تکمیل کنید",
              {
                type: "error",
              }
            );
            return;
          }
        } else if (this.$store.state.auth.role == "builder") {
          if (
            this.$store.state.auth.loggedIn &&
            !this.$store.state.auth.is_complate
          ) {
            toast(
              "برای خرید تعرفه اطلاعات پروفایل خود را تکمیل کنید",
              {
                type: "error",
              }
            );
            return;
          }
          if (
            this.$store.state.auth.loggedIn &&
            this.$store.state.auth.is_complate &&
            this.$store.state.auth.is_allowed == "no"
          ) {
            toast(
              "پروفایل شما تکمیل شده است، اما برای خرید تعرفه نیاز است هویت شما تایید شود.",
              {
                type: "error",
              }
            );
            return;
          }
        }
      }
      this.$router.push(route);
    },
    openComponent(menuKey) {
      console.log("kjasjnkasjnaskcnsakj");
      this.left_menu[menuKey] = true;
      history.pushState(null, "", location.href);
      document.body.style.overflowY = "hidden";
    },
    closeComponent(menuKey) {
      if (!this.isBackAction) {
        history.back();
      }
      this.left_menu[menuKey] = false;
      document.body.style.overflowY = "auto";
    },
    handleBackButton() {
      let windowWidth = window.innerWidth;
      if (this.ShowModel && windowWidth < 700) {
        this.ShowModel = false;
        return;
      }
      if (this.newStory && windowWidth < 700) {
        this.newStory = false;
        return;
      }
      if (this.selectedFollow != "") {
        this.selectedFollowClose();
        return;
      }
      if (this.isFilterOpen) {
        return;
      }
      const isAnyOpen = Object.values(this.left_menu).some(
        (val) => val === true
      );
      if (isAnyOpen) {
        this.isBackAction = true;
        Object.keys(this.left_menu).forEach((key) => {
          this.left_menu[key] = false;
        });
        document.body.style.overflowY = "auto";
        this.isBackAction = false;
      }
    },
    user_info_func() {
      let self = this;
      var user_id = 0;
      var uid = 0;

      if (this.$store.state.auth.loggedIn) {
        user_id = this.$store.state.auth.uid;
        uid = this.$store.state.auth.uid;
      }

      this.helperGet(
        "user-infos",
        "uid=" +
          uid +
          "&user_id=" +
          user_id +
          "&page=" +
          "1" +
          "&list_type=" +
          "own_profile" +
          `${
            this.$store?.state?.auth?.role == "builder"
              ? "&post_type=portfolio"
              : ""
          }`
      ).then((res) => {
        self.user_info = {
          avatar: res.data.avatar,
          uid: res.data.uid,
          role: res.data.role,
          fname: res.data.fname,
          lname: res.data.lname,
          company_name: res.data.company_name,
          mobile: res.data.mobile,
          code_melli: res.data.code_melli,
          address: res.data.address,
          work_history: res.data.work_history,
          phone: res.data.phone,
          telegram: res.data.telegram,
          winestahats_app: res.data.whats_app,
          whats_app: res.data.whatsup,
          insta: res.data.instagram,
          description: res.data.description,
          category_id: Array.isArray(res.data.category_id)
            ? res.data.category_id.map(Number)
            : [],
          b_activity_type: res.data.b_activity_type || [],
        };
        self.completeInfos = res.data;
        this.LoadingSkeleton = false;
      });
    },

    getCustomerinfo() {
      let self = this;
      this.helperPost("current-user-info").then((r) => {
        if (r.data.result == "1") {
          self.$store.commit("setAuth", r.data);
          self.$store.dispatch("checkAuth");
          this.visitStatChecked = r.data.request_visit == 1;
        }
      });
    },
    getJalaliYears() {
      const faYear = new Intl.DateTimeFormat("fa-IR-u-ca-persian", {
        year: "numeric",
      }).format(new Date());

      const enYear = this.convertPersianToEnglish(faYear);

      for (let i = +enYear; i >= 1370; i--) {
        this.years.push(i.toString());
      }
    },
    convertPersianToEnglish(str) {
      const persianNumbers = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];
      const englishNumbers = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"];

      return str
        .split("")
        .map((ch) => {
          const index = persianNumbers.indexOf(ch);
          return index > -1 ? englishNumbers[index] : ch;
        })
        .join("");
    },
    handleCheckboxChange(event, type) {
      if (event.target.checked) {
        if (!this.user_info.b_activity_type.includes(type)) {
          this.user_info.b_activity_type = [
            ...this.user_info.b_activity_type,
            type,
          ];
        }
      } else {
        this.user_info.b_activity_type = this.user_info.b_activity_type.filter(
          (e) => e !== type
        );
      }
      console.log(
        "this.user_info.b_activity_type",
        this.user_info.b_activity_type
      );
    },
  },
  watch: {
    showFollowed(val) {
      if (val) {
        this.attachScrollEvent();
      } else {
        this.detachScrollEvent();
      }
    },

    selectedFollow(val) {
      // وقتی تب عوض میشه، صفحه‌بندی رو reset کن و داده‌ها رو لود کن
      if (val === "follower") {
        this.follower.page = 1; // ریست کردن صفحه برای followers
        this.follower.list = []; // پاک کردن لیست قبلی
        this.follower.hasMorePages = true; // reset کردن hasMorePages
        this.getfollower(); // لود کردن داده‌ها
      } else if (val === "following") {
        this.following.page = 1; // ریست کردن صفحه برای following
        this.following.list = []; // پاک کردن لیست قبلی
        this.following.hasMorePages = true; // reset کردن hasMorePages
        this.getfollowing(); // لود کردن داده‌ها
      }

      this.detachScrollEvent();
      this.attachScrollEvent();
    },
  },
  async mounted() {
    await this.$nextTick();
    if (this.$store.state.auth.loggedIn) {
      if (!this.$store.state.auth.is_complate) {
        toast("لطفا اطلاعات پروفایل خود را تکمیل کنید", {
          type: "warning",
        });
      }
    }
    this.load_district();
    this.user_info_func();
    this.getJalaliYears();
    this.handleFollowHeight();
    this.getCustomerinfo();
    this.editStyleHandler();
    window.addEventListener("resize", function () {
      this.editStyleHandler;
      this.handleFollowHeight;
    });
    // window.addEventListener("resize", this.handleFollowHeight);
    window.addEventListener("popstate", this.handleBackButton);
    this.userInforamtion = JSON.parse(localStorage.getItem("auth"));
    setInterval(() => {
      this.loadTheme();
    }, 100);
    // this.reloadPage();
    const routeComp = this.$route.params.comp;
    if (routeComp) {
      this.LoadingSkeleton = false;
    }
    let showFollow = localStorage.getItem("showFollow");
    if (showFollow) {
      this.selectedFollow = showFollow;
      this.LoadingSkeleton = false;
      this.$nextTick(() => {
        localStorage.removeItem("showFollow");
      });
    }
  },
  beforeMount() {
    window.removeEventListener("popstate", this.handleBackButton);
  },
};
</script>

<style lang="scss" scoped>
.loader {
  width: 25px !important;
  height: 25px !important;
  margin-bottom: 5px;
}

.requestVisit {
  display: flex;
  align-items: center;
  gap: 4px;

  p {
    margin-bottom: 0 !important;
  }
}

.dark {
  .switchInput {
    input:checked + .slider {
      box-shadow: inset 0 0 4px rgba(255, 255, 255, 0.12),
        inset 0 3px 6px rgba(255, 255, 255, 0.15);
    }

    .slider {
      background: #20262c;
      box-shadow: inset 0 0 4px rgba(255, 255, 255, 0.07),
        inset 0 2px 4px rgba(255, 255, 255, 0.04), 0 1px 1px rgba(0, 0, 0, 0.8);
    }
  }
}

.switchInput {
  position: relative;
  display: inline-block;
  width: 54px;
  height: 26px;
  flex-shrink: 0;

  &.loading {
    pointer-events: none;
  }

  input {
    display: none;
  }

  input:checked + .slider {
    background: #0096c7;
    box-shadow: inset 0 0 4px rgba(0, 0, 0, 0.12),
      inset 0 3px 6px rgba(0, 0, 0, 0.15);

    &::before {
      transform: translateX(24px);
      background: #fff;
    }
  }

  .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: #f6f6f4;
    border-radius: 50px;
    transition: 0.25s ease;
    box-shadow: inset 0 0 4px rgba(0, 0, 0, 0.07),
      inset 0 2px 4px rgba(0, 0, 0, 0.04), 0 1px 1px rgba(255, 255, 255, 0.8);

    &::before {
      content: "";
      position: absolute;
      height: 20px;
      width: 20px;
      left: 3px;
      top: 3px;
      background: #ffffff;
      border-radius: 50%;
      transition: 0.25s ease;
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08), 0 4px 8px rgba(0, 0, 0, 0.04);
    }
  }
}
@media (max-width: 700px) {
  .creditSignSkeletor {
    margin-top: 0 !important;
  }

  .phoneclassSkeletor {
    margin-bottom: 10px !important;
    margin-top: 10px !important;
  }

  .PhoneClassNumber {
    &.addressProfile {
      align-items: center !important;
      &.requestVisit {
        margin-block: -4px 18px !important;
      }
    }
  }

  .container1 {
    .profileImageSkeletor {
      width: 94% !important;
      display: block !important;
      margin: 0 auto !important;
      margin-bottom: -16px !important;
    }

    .firstNameSkeletor,
    .mobileStatisticsSkeletor {
      display: none !important;
    }
  }

  // .creditSign {
  //   display: flex;
  //   align-items: center;
  //   justify-content: space-between;

  //   .PhoneClassNumber {
  //     width: calc(100% - 36px) !important;

  //     span {
  //       display: inline !important;
  //       width: auto !important;
  //     }
  //   }

  //   .addCreditBtn {
  //     flex-shrink: 0;
  //     padding: 6px 8px;
  //     background: #0096c7;
  //     color: #fff;
  //     border-radius: 6px;
  //     display: flex;
  //     align-items: center;
  //     justify-content: center;
  //     font-size: 12px;
  //   }
  // }
}

.no-result {
  text-align: center;
  margin-top: 5rem;
}

@media (max-width: 1250px) and (min-width: 700px) {
  .desktopAddCreditskeletor {
    margin-top: 18px !important;
    margin-bottom: 28px !important;
  }
}

.skeleton-wrapper {
  background: #fff;
  border-radius: 8px;
  padding: 15px;
  margin-bottom: 20px;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);
}

.TopShowToUSerNAme {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
  gap: 10px;
}

.ImageTopShowToUSerNAme {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #f0f0f0;
  margin-right: 10px;
}

.titleTopShowToUSerNAme {
  width: 150px;
  height: 30px;
  background: #f0f0f0;
  border-radius: 4px;
}

.skeleton-image {
  width: 100%;
  height: 200px;
  background: #f0f0f0;
  border-radius: 8px;
  margin-bottom: 15px;
}

.skeleton-text {
  width: 100%;
  height: 15px;
  background: #f0f0f0;
  border-radius: 4px;
  margin-bottom: 10px;
}

.skeleton-text.short {
  width: 60%;
}
.no-result {
  text-align: center;
  margin-top: 6rem;
}

.dark {
  .editMapContainer {
    .containerLabel {
      color: #aaa;
    }

    .containerMap {
      :deep(.leaflet-map) {
        border: 1px solid rgb(85, 90, 100) !important;
        box-shadow: 0 1px 2px 0 rgba(255, 255, 255, 0.1) !important;
      }
    }

    .containerInput {
      input {
        background: #101a23 !important;
        color: #fff !important;
        border: 1px solid rgb(85, 90, 100) !important;
        box-shadow: 0 1px 2px 0 rgba(255, 255, 255, 0.1) !important;
      }
    }
  }
}

.editMapContainer {
  width: 100%;
  grid-column: span 2;

  .containerLabel {
    margin-top: 15px;
    margin-bottom: 10px;
    margin-right: 10px;
    font-size: 1rem;
    color: #333;
    font-family: "iranyekanB";
  }

  .containerMap {
    width: 100%;

    :deep(.leaflet-map) {
      width: 100%;
      height: 300px;
      border-radius: 0.375rem;
      border: 1px solid rgb(209, 213, 219);
      box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);
    }
  }

  .containerInput {
    margin-top: 15px;
    input {
      width: 100%;
      height: 40px;
      padding: 0 10px;
      border-radius: 0.375rem;
      border: 1px solid rgb(209, 213, 219);
      box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);
      font-size: 0.9rem;
    }
  }
}

.ChildShowInputFormToUser {
  label {
    span {
      color: #f00;
    }
  }
}

.editMapContainer {
  .containerLabel {
    span {
      color: #f00;
    }
  }
}
.addPic_text {
  span {
    color: #f00;
  }
}

.activityOptionsList {
  width: 90%;
  margin-top: 6px;
  margin-left: auto;
  margin-right: auto;
  .listWrapper {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 18px 12px;

    .listThumb {
      display: flex;
      align-items: center;
      gap: 8px;

      label {
        margin: 0 !important;
      }

      .hiddenInput {
        display: none;
      }

      .filterListInput {
        cursor: pointer;
        .customCheckBox {
          position: relative;
          width: 20px;
          height: 20px;
          border: 1px solid #474747;
          box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);
          border-radius: 2px;
          flex-shrink: 0;

          &.checked {
            border: 1px solid #0096c7;

            .checkedTick {
              opacity: 1;
            }
          }

          input {
            position: absolute;
            inset: 0;
            width: 100%;
            height: 100%;
            cursor: pointer;
            z-index: 2;
            opacity: 0;
          }

          .checkedTick {
            position: absolute;
            inset: 0;
            width: 100%;
            height: 100%;
            background: #0096c7;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #fff;
            font-size: 0.75rem;
            opacity: 0;
          }
        }
      }

      .filterListTitle {
        font-size: 0.75rem;
        cursor: pointer;
        display: flex;
        align-items: flex-start;
        gap: 4px;
        font-weight: 200;

        span {
          font-size: 0.9rem;
          display: block;
          height: 0;
        }
      }
    }
  }
}

@media (max-width: 700px) {
  .ShowInputFormToUser1 {
    &.profileEditForm {
      display: block;
    }
  }

  .resProfileEditBtn {
    font-size: 0.95rem;
  }
}

@media (min-width: 500px) {
  .ChildShowInputFormToUser {
    &.activityType {
      grid-column: span 2;
    }
  }
}

.desktopAddCreditBtnWrapper {
  margin-bottom: 32px;
}

/* Loading indicator برای lazy loading */
.lazy-loading-indicator {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
  margin: 10px 0;

  .loading-spinner {
    width: 30px;
    height: 30px;
    border: 3px solid #f3f3f3;
    border-top: 3px solid #0096c7;
    border-radius: 50%;
    animation: spin 1s linear infinite;
    margin-bottom: 10px;
  }

  p {
    color: #666;
    font-size: 14px;
    margin: 0;
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
